module.exports = __webpack_public_path__ + "static/floor-plan-2-ba78f2d3738bdb76a60a1f1904ef3513.jpg";